import React from "react";
import "./header.css";
import { Link } from "react-router";
import logo from "./../../logo.jpg";

function Header({ resume = false, onContact }) {
  return (
    <header className="nav">
      <div className="container nav-inner">
        <Link className="brand" to="/">
          <img src={logo} className="mark" alt="Devtechinvento logo" />
          <span>Devtechinvento<small>Gayan N. Wimalarathna</small></span>
        </Link>
        <nav className="nav-links">
          {resume ? (
            <>
              <Link to="/">Home</Link>
              <a href="#summary">Summary</a>
              <a href="#experience">Experience</a>
              <a href="#skills">Skills</a>
              <a href="#certs">Certifications</a>
              <Link className="btn btn-primary" to="/#contact">Contact</Link>
            </>
          ) : (
            <>
              <a href="#home">Home</a>
              <a href="#services">Services</a>
              <a href="#about">About</a>
              <a href="#skills">Skills</a>
              <Link to="/resume">Résumé</Link>
              <button className="btn btn-primary" type="button" onClick={onContact}>
                Contact Me
              </button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}

export default Header;
